export default function AboutBar() {
  const points = [
    { icon: "ri-database-2-line", title: "只聚合公开信息", desc: "起底与深扒仅基于可公开核验的物料，不采信单一匿名私信爆料。" },
    { icon: "ri-shield-check-line", title: "可信度分级标注", desc: "每条内幕标注实锤 / 存疑 / 待核实三档，不被情绪带节奏。" },
    { icon: "ri-edit-line", title: "接受勘误与申诉", desc: "档案内容支持逐条指正，确认有误的表述会在档案内标注并修正。" },
  ];

  return (
    <section id="about" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="overflow-hidden rounded-xl border border-foreground-950/8 bg-background-100/60">
          <div className="grid grid-cols-1 gap-px bg-foreground-950/8 lg:grid-cols-[1.1fr_1fr]">
            <div className="bg-background-50 p-6 md:p-8">
              <p className="flex items-center gap-3 font-label text-xs tracking-[0.3em] text-primary-600 uppercase">
                <span className="inline-block h-px w-8 bg-primary-500" />
                本站怎么扒
              </p>
              <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                网黑料不是「爆料台」，
                <br className="hidden sm:block" />
                是「黑历史资料整理站」
              </h2>
              <p className="mt-3 text-sm leading-6 text-foreground-600">
                深扒与起底的目的不是泼脏水，而是把人物背景里那些对得上、对不上的地方摊开给读者自己判断。要了解人物背后的故事与内幕，先看证据，再下结论。
              </p>
              <p className="mt-3 text-sm leading-6 text-foreground-600">
                这里的一切内容，仅作公开信息检索与背景分析之用，不代表对任何主体的定性结论。
              </p>
            </div>

            <div className="grid grid-cols-1 gap-px bg-foreground-950/8 sm:grid-cols-3 lg:grid-cols-1">
              {points.map((p) => (
                <div key={p.title} className="flex gap-3 bg-background-50 p-5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={p.icon + " text-lg"} />
                  </span>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-[13px] leading-5 text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}